module.exports = __webpack_public_path__ + "img/reject.0eab5d1b.png";